import {
    faBed,
    faBus,
    faCartShopping,
    faGlobe,
    faLandmark,
    faLocationDot,
    faMap,
    faMicrophone,
    faMoon,
    faPersonRunning,
    faUsers,
    faUtensils
} from '@fortawesome/free-solid-svg-icons';

// ── Map styles ────────────────────────────────────────────────────────────────

const CARTO_BASE = 'https://basemaps.cartocdn.com/gl';

export const STYLES = {
    positron: `${CARTO_BASE}/positron-gl-style/style.json`,
    voyager: `${CARTO_BASE}/voyager-gl-style/style.json`,
    dark: `${CARTO_BASE}/dark-matter-gl-style/style.json`
};

export const STYLE_OPTIONS = [
    { id: 'voyager', label: 'Farger', icon: faGlobe },
    { id: 'positron', label: 'Gråskala', icon: faMap },
    { id: 'dark', label: 'Mørk', icon: faMoon }
];

// ── Categories ────────────────────────────────────────────────────────────────

// Colors aligned with design tokens in _tokens.scss and _program.scss
export const CATEGORY_META = {
    felles: { color: '#ffb114', bg: '#fff6e3', label: 'Felles', icon: faUsers }, // --color-warning
    konferanse: { color: '#6b4aa3', bg: '#f1ecfa', label: 'Konferanse', icon: faMicrophone }, // --program-konferanse
    trening: { color: '#004b8d', bg: '#e3ecf5', label: 'Trening', icon: faPersonRunning }, // --color-brand-secondary
    servering: { color: '#0f8737', bg: '#ebfcef', label: 'Servering', icon: faUtensils }, // --color-success
    overnatting: { color: '#7c5c2b', bg: '#fdf5e8', label: 'Overnatting', icon: faBed },
    dagligvare: { color: '#0e7490', bg: '#e6f7fb', label: 'Dagligvare', icon: faCartShopping },
    transport: { color: '#475569', bg: '#f1f5f9', label: 'Transport', icon: faBus },
    attraksjon: { color: '#92400e', bg: '#fffbeb', label: 'Attraksjon', icon: faLandmark },
    annet: { color: '#506c64', bg: '#f0f2f1', label: 'Annet', icon: faLocationDot } // --color-brand-support
};

export const CATEGORIES = [
    { id: 'alle', label: 'Alle steder' },
    { id: 'felles', label: 'Felles' },
    { id: 'konferanse', label: 'Konferanse' },
    { id: 'trening', label: 'Trening' },
    { id: 'servering', label: 'Servering' },
    { id: 'overnatting', label: 'Overnatting' },
    { id: 'dagligvare', label: 'Dagligvare' },
    { id: 'transport', label: 'Transport' },
    { id: 'attraksjon', label: 'Attraksjon' },
    { id: 'annet', label: 'Annet' }
];
